export const services = [
  {
    title: 'Accounting & Bookkeeping',
    description: 'Accurate books, clean reporting, and dependable financial visibility for confident decisions.',
    icon: 'FiBarChart2',
    accent: 'green',
  },
  {
    title: 'Tax & Compliance',
    description: 'Stay prepared, compliant, and ahead with practical tax planning and reporting support.',
    icon: 'FiShield',
    accent: 'navy',
  },
  {
    title: 'Business Advisory',
    description: 'Turn financial data into strategic direction with modeling, forecasting, and growth planning.',
    icon: 'FiCompass',
    accent: 'blue',
  },
  {
    title: 'AI Solutions',
    description: 'Use practical artificial intelligence to improve productivity, insight, and customer experiences.',
    icon: 'FiCpu',
    accent: 'green',
  },
  {
    title: 'Workflow Automation',
    description: 'Remove repetitive work and connect people, approvals, and systems into better workflows.',
    icon: 'FiZap',
    accent: 'orange',
  },
  {
    title: 'Custom Software Development',
    description: 'Purpose-built digital products that fit your workflows, customers, and competitive edge.',
    icon: 'FiCode',
    accent: 'navy',
  },
  {
    title: 'Business Process Automation',
    description: 'Standardize operations and create scalable processes that help your team move faster.',
    icon: 'FiRefreshCw',
    accent: 'blue',
  },
  {
    title: 'Cloud & Integration Services',
    description: 'Build a connected technology foundation across finance, data, and business platforms.',
    icon: 'FiCloud',
    accent: 'green',
  },
];

export const projects = [
  {
    name: 'AI Accounting Platform',
    industry: 'Financial Services',
    challenge: 'Manual categorization and fragmented client reporting slowed every close.',
    solution: 'An intelligent accounting workspace with automated classification, review queues, and live reporting.',
    results: '60% faster monthly close',
    technologies: 'React · OpenAI · Supabase',
    icon: 'FiCpu',
  },
  {
    name: 'Financial Reporting Dashboard',
    industry: 'Professional Services',
    challenge: 'Leadership lacked one reliable view of profitability across business units.',
    solution: 'A role-based dashboard connecting accounting data to actionable performance insights.',
    results: '2x faster decision cycles',
    technologies: 'React · PostgreSQL · Power BI',
    icon: 'FiPieChart',
  },
  {
    name: 'Workflow Automation System',
    industry: 'Construction',
    challenge: 'Approvals and job documentation were managed across disconnected tools.',
    solution: 'A unified workflow that automated intake, routing, approvals, and notifications.',
    results: '35 hours saved per month',
    technologies: 'Power Automate · SharePoint · Twilio',
    icon: 'FiGitBranch',
  },
  {
    name: 'Client Portal',
    industry: 'Tax & Advisory',
    challenge: 'Secure document exchange created delays for both advisors and clients.',
    solution: 'A polished client portal for uploads, requests, status tracking, and communication.',
    results: '42% faster client onboarding',
    technologies: 'Next.js · Supabase · Stripe',
    icon: 'FiUsers',
  },
  {
    name: 'Business Intelligence Dashboard',
    industry: 'E-commerce',
    challenge: 'Revenue, inventory, and marketing data lived in separate systems.',
    solution: 'A connected intelligence layer that made performance trends visible in real time.',
    results: '18% improvement in margin',
    technologies: 'React · PostgreSQL · Claude',
    icon: 'FiActivity',
  },
  {
    name: 'Bank Feed Integration Platform',
    industry: 'Startups',
    challenge: 'Growing transaction volumes made reconciliation increasingly unreliable.',
    solution: 'A secure bank data integration with intelligent matching and exception handling.',
    results: '90% automated reconciliation',
    technologies: 'Plaid · React · Xero',
    icon: 'FiLink',
  },
];

export const industries = [
  ['Professional Services', 'FiBriefcase'],
  ['E-commerce', 'FiShoppingBag'],
  ['Construction', 'FiTool'],
  ['Healthcare', 'FiHeart'],
  ['Real Estate', 'FiHome'],
  ['Startups', 'FiTrendingUp'],
  ['Manufacturing', 'FiSettings'],
  ['Hospitality', 'FiCoffee'],
];

export const stack = [
  'QuickBooks',
  'Xero',
  'Wave',
  'Supabase',
  'PostgreSQL',
  'React',
  'Next.js',
  'Power Automate',
  'SharePoint',
  'OpenAI',
  'Claude',
  'Plaid',
  'Twilio',
  'Stripe',
];

export const caseStudies = [
  {
    client: 'Multi-location advisory firm',
    category: 'Accounting transformation',
    before: 'Month-end close took 14 days with limited visibility between reviews.',
    after: 'A connected reporting and close process reduced the close to 6 days.',
    metric: '57%',
    label: 'faster close',
  },
  {
    client: 'Scaling e-commerce brand',
    category: 'Automation & intelligence',
    before: 'Teams spent 20+ hours every week reconciling orders and payouts.',
    after: 'Automated matching and exception workflows reduced manual effort dramatically.',
    metric: '80%',
    label: 'less manual work',
  },
  {
    client: 'Regional construction group',
    category: 'Business advisory',
    before: 'Project profitability was reviewed after the fact, limiting corrective action.',
    after: 'Live job-cost reporting helped leaders act earlier and protect margins.',
    metric: '24%',
    label: 'margin improvement',
  },
];

export const values = [
  {
    number: '01',
    title: 'Clarity',
    text: 'We turn complexity into an understandable path forward.',
  },
  {
    number: '02',
    title: 'Ownership',
    text: 'We treat your goals and outcomes like they are our own.',
  },
  {
    number: '03',
    title: 'Progress',
    text: 'We focus on practical improvements that compound over time.',
  },
];

export const team = [
  ['Finance specialists', 'Accounting, reporting, and compliance expertise.'],
  ['Strategic advisors', 'Practical guidance for your next stage of growth.'],
  ['Technology builders', 'Reliable systems designed around how you work.'],
];